import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PharmacyApiConfiguration } from '../apiConfiguration';
import { ServiceBase } from 'app/shared/infrastructure';

@Injectable({
    providedIn: 'root'
})

export class MedicationIngredientService extends ServiceBase {

    private actionUrl: string;
    private _baseUrl: string;
    private _byMedicationUrl: string;
    private _availableUrl: string;

    constructor(
        private _http: HttpClient,
        private _configuration: PharmacyApiConfiguration
    ) {
        super();

        this.actionUrl = _configuration.server;
        this._baseUrl = this.actionUrl + _configuration.medicationIngredient.url;
        this._byMedicationUrl = this.actionUrl + _configuration.medicationIngredient.byMedication;
        this._availableUrl = this.actionUrl + _configuration.medicationIngredient.available;
    }

    getByMedicationId = (medicationId: number): Observable<any[]> => {
        return this._http.get<any[]>(`${this._byMedicationUrl}/${medicationId}`);
    }

    getAvailableIngredients = (): Observable<any[]> => {
        return this._http.get<any[]>(this._availableUrl);
    }

    addIngredient = (dto: any): Observable<any> => {
        return this._http.post<any>(this._baseUrl, dto);
    }

    removeIngredient = (medicationId: number, ingredientId: number): Observable<any> => {
        const url = `${this._baseUrl}?medicationId=${medicationId}&ingredientId=${ingredientId}`;
        return this._http.delete<any>(url);
    }
}